import { isUndefined } from './lang'

function noop() {}

/**
 * Countdown 计时器类
 *
 * @example
 * const c = new Countdown(time)
 * const c = new Countdown(options)
 * const c = new Countdown(time, options)
 * const c = new Countdown(time, update)
 * const c = new Countdown(time, update, options)
 *
 * @param {Number} [time] - 倒计时开始时间
 * @param {Function} [update] - 更新函数
 * @param {{time:Number, start:Function, update:Function, finish:Function}} [options] - 配置项，可配置 time, start, update, finish
 *
 */
export default function Countdown(time, update, options) {
  if (arguments.length === 0) {
    time = 0
    update = noop
    options = {}
  } else if (arguments.length === 1) {
    if (typeof time === 'object') {
      options = time
      time = options.time || 0
      update = options.update || noop
    } else {
      update = noop
      options = {}
    }
  } else if (arguments.length === 2) {
    if (typeof update === 'function') {
      options = {}
    } else {
      options = update
      update = options.update || noop
    }
  }
  time = parseInt(time, 10)
  if (time < 0) {
    throw new Error('倒计时时间不能小于 0')
  }
  this._startTime = time
  this._currentTime = time
  this._timer = null
  this._isRunning = false
  this._isStop = true
  this._callbacks = {
    start: options.start || noop,
    update: update,
    finish: options.finish || noop
  }
}

Countdown.prototype._call = function (hook) {
  this._callbacks[hook].call(this, this._currentTime)
}

Countdown.prototype.start = function () {
  if (!this._isStop) {
    throw new Error('请先停下当前的倒计时')
  }
  this._isStop = false
  this._isRunning = true
  this._call('start')
  if (this._currentTime <= 0) {
    this.stop()
    return
  }
  var self = this
  var lastTime, delay, lastGap

  function timeout() {
    self._timer = setTimeout(function () {
      if (!self._isRunning) {
        return
      }
      var currentTime = new Date().getTime()
      delay = currentTime - lastTime - lastGap
      lastTime = currentTime
      lastGap = 1000 - delay
      self._currentTime -= 1
      self._call('update')
      if (self._currentTime <= 0) {
        self.stop()
      } else {
        timeout()
      }
    }, lastGap)
  }
  lastTime = new Date().getTime()
  delay = 0
  lastGap = 1000
  timeout()
  return this
}

Countdown.prototype.pause = function (pause) {
  if (this._isStop) {
    return false
  }
  var state = this._isRunning
  if (!isUndefined(pause)) {
    state = pause
  }
  this._isRunning = !state
}

Countdown.prototype.stop = function () {
  if (this._isStop) {
    return false
  }
  this._isRunning = false
  this._isStop = true
  clearTimeout(this._timer)
  this._timer = null
  this._currentTime = this._startTime
  this._call('finish')
}

Countdown.prototype.destroy = function () {
  clearTimeout(this._timer)
  this._timer = null
  this._isRunning = false
  this._isStop = true
  return null
}
